import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import AutocompleteInput from './AutocompleteInput';

interface IssueCodeInputProps {
  onChange: (e: any) => void;
  value: string | undefined;
  name?: string;
  label?: string;
  [x: string]: any;
}

const DEFAULT_CODES = [
  'O_AUTH_AUTHENTICATION_ERROR',
  'PAYMENT_NOT_AVAILABLE',
  'ACTIVATION_CODE_EXCEPTION',
  'INVITATION_NOT_APPLICABLE',
  'ADDITIONAL_AUTHENTICATION_REQUIRED',
  'REPORTS_TO_WITHOUT_TERMINAL',
  'PAYMENT_INSTRUMENT_UNAVAILABLE',
  'REFRESH_TOKEN_REQUIRED',
  'AUTHORIZATION_TIMEOUT',
  'OTHER_SERVER_ERROR',
  'PAYMENT_VALIDATION_EXCEPTION',
  'NOT_AUTHORIZED',
  'EMPLOYEE_WITHOUT_TERMINAL',
  'NOT_AUTHENTICATED',
  'PARAMETER_MISSING',
  'DAY_SHIFT_ERROR',
  'OTHER_CLIENT_ERROR',
  'KEY_NOT_REGISTERED',
  'NOT_SUFFICIENT_FUNDS',
  'PROFILE_BLOCKED',
  'PROFILE_KYC_LEVEL_MISMATCH',
  'EMPLOYEE_IS_PART_OF_TREE',
  'CURRENCY_PAIR_NOT_FOUND',
  'REQUEST_ENTITY_TOO_LARGE',
  'MANUAL_CANCELLATION',
  'IMMUTABLE_FIELD_MODIFIED',
  'RESOURCE_NOT_AVAILABLE',
  'NOT_FOUND_ERROR',
  'REVERSAL_NOT_POSSIBLE',
  'FEATURE_NOT_AVAILABLE',
  'FINANCIAL_TRANSACTION_API_EXCEPTION',
  'PARAMETER_INVALID',
  'PROFILE_INVALID',
  'PAYMENT_DETAILS_INVALID',
  'JSON_INVALID',
  'LOCALIZATION_NOT_FOUND',
  'GENERIC_API_EXCEPTION',
  'TOO_MANY_REQUESTS',
  'BENEFICIARY_NOT_AVAILABLE',
  'AUTHORIZATION_ATTEMPTS_LIMIT_EXCEEDED',
  'UNSUPPORTED_AUTHORIZATION',
  'RATE_LIMIT_EXCEEDED',
  'FEATURE_NOT_SUPPORTED',
  'NOT_FOUND',
  'RESOURCE_ALREADY_EXISTS',
  'EVENT_CONSTRAINT_VIOLATION',
  'INVITATION_LIMIT_REACHED',
  'EMPLOYEE_EXCEPTION',
  'DAY_SHIFT_EXCEPTION',
  'TENANT_INVALID',
  'ACTION_NOT_APPLICABLE',
  'RESOURCE_MISSING',
  'PROFILE_NOT_AVAILABLE',
  'REQUEST_ENTITY_TOO_LARGE_ERROR',
  'PARTY_NOT_AVAILABLE',
  'LIMIT_REACHED',
  'AMOUNT_INVALID',
  'AMOUNT_TOO_SMALL',
  'CONDITIONS_CHANGED',
  'CURRENCY_NOT_SUPPORTED',
  'INTERNAL_JSON_INVALID',
  'OPERATION_NOT_APPLICABLE',
  'TRN_MONITORING_FAILED_WITH_ERROR',
  'TRN_MONITORING_DENY',
  'TRANSACTION_UNDER_INVESTIGATION',
];

const IssueCodeInput: FC<IssueCodeInputProps> = (props) => {
  const { onChange, value, name, label, className } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.headTransactions.list.filters.${key}`);
  const choices = DEFAULT_CODES.map((code) => {
    return { value: code, text: code, label: code };
  }).sort((a, b) => a.label.localeCompare(b.label));
  return (
    <AutocompleteInput<string | undefined>
      options={choices}
      className={className}
      label={label || t('issueCode')}
      value={value}
      onInputChange={(_, value: any) => {
        onChange?.({ target: { name, value } });
      }}
      renderOption={(option) => (
        <div
          style={{ wordBreak: 'break-word', overflowWrap: 'break-word', textOverflow: 'ellipsis' }}
        >
          {option?.label}
        </div>
      )}
      allowEmpty
      disableHelperText
    />
  );
};

export default IssueCodeInput;
